import  React, {createContext, useState} from  "react";
// Context ini saya cari referensi di google, 
// referensi: https://dev.to/imshines/how-to-create-a-theme-toggle-in-react-using-context-api-3a5i
// Context has been created
const  ThemeContext = createContext(false);
// Provider
const  ThemeProvider = ({ children })  =>  {
    const  [toggle, setToggle]  =  useState(false);
    const toggleFunction = () => {
    setToggle(!toggle);
};
return  (
    <ThemeContext.Provider value={{toggle, toggleFunction}}>
        {children}
    </ThemeContext.Provider>
    );
};
export  {ThemeContext, ThemeProvider};